import { useEffect } from 'react'
import {
  Datagrid,
  DateField,
  Pagination,
  ReferenceManyField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  useRefresh,
  useRecordContext,
} from 'react-admin'
import FileActionButtons from './FileActionButtons'

const AutoRefresh = () => {
  const refresh = useRefresh()
  const record = useRecordContext()

  useEffect(() => {
    // Check if import is still in progress
    const isComplete = record?.status?.import_log_status === 'complete'

    if (!isComplete && record?.id) {
      // Poll every 3 seconds if not complete
      const interval = setInterval(() => {
        refresh()
      }, 3000)

      return () => clearInterval(interval)
    }
    return undefined
  }, [record?.status?.import_log_status, record?.id, refresh])

  return null
}

const ImportLogShow = () => {
  return (
    <Show>
      <TabbedShowLayout>
        <Tab label="summary">
          <AutoRefresh />
          <TextField source="filename" emptyText="n/a" />
          <TextField source="user.name" emptyText="n/a" />
          <TextField source="organisation.name" emptyText="n/a" />
          <DateField source="created" label="Date uploaded" />
          <TextField
            source="status.import_log_status"
            label="Import Log Status"
          />
          <TextField
            source="status.import_log_total"
            label="Import Log Total"
          />
          <TextField
            source="status.import_log_current"
            label="Import Log Current"
          />
          <TextField
            source="status.import_log_cleaning_status"
            label="Processing Status"
            sx={{ fontStyle: 'italic', color: 'info.main' }}
          />
          <TextField
            source="status.import_log_error"
            label="Error Message"
            sx={{ color: 'error.main', whiteSpace: 'pre-wrap' }}
          />
          <TextField
            source="status.organisation_status"
            label="Organisation Map Status"
          />
          <TextField
            source="status.organisation_total"
            label="Organisation Map Total"
          />
          <TextField
            source="status.organisation_current"
            label="Organisation Map Current"
          />
          <FileActionButtons />
        </Tab>
        <Tab label="vendors">
          <ReferenceManyField
            reference="vendors"
            target="import_log_id"
            source="id"
            pagination={<Pagination />}
          >
            <Datagrid bulkActionButtons={false}>
              <TextField source="name" label="Vendor" />
              <TextField source="territory.name" label="Territory" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
        <Tab label="transactions">
          <ReferenceManyField
            reference="transactions"
            target="import_log_id"
            source="id"
            pagination={<Pagination />}
          >
            <Datagrid bulkActionButtons={false}>
              <TextField source="invoice_vendor_name" label="Vendor" />
              <TextField source="amount" label="Amount" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  )
}

export default ImportLogShow
